import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { IInvoiceData } from '../../../../store/ducks/invoices/types';
import DuplicatesFilter from './DuplicatesFilter';
import DuplicatesTable from './DuplicateTable';
import { Container } from './styles';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

const Duplicates: React.FC = () => {
  const dispatch = useDispatch();
  const invoicesState = useSelector(
    (state: ApplicationState) => state.invoices
  );
  const [filteredInvoices, setFilteredInvoices] = useState<IInvoiceData[]>(
    invoicesState.invoices || []
  );

  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    if (invoicesState.invoices) {
      setFilteredInvoices(invoicesState.invoices);
    }
    if (invoicesState.invoices?.length) {
      dispatch(
        sendTagging({
          screenName: 'LG:Financas:MinhasFinancas:Duplicatas',
          event: 'page_view'
        })
      );
    }
  }, [invoicesState.invoices, dispatch]);

  return (
    <Container>
      <div>
        <DuplicatesFilter
          invoicesState={invoicesState}
          filteredInvoices={filteredInvoices}
          setFilteredInvoices={setFilteredInvoices}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          onCleanFilters={() =>
            setFilteredInvoices(invoicesState.invoices || [])
          }
        />

        {invoicesState.loading && (
          <Skeleton count={6} style={{ margin: '0.5rem 0' }} />
        )}

        {!invoicesState.loading && (
          <DuplicatesTable
            filteredInvoices={filteredInvoices}
            searchTerm={searchInput}
            key={JSON.stringify(searchInput)}
          />
        )}
      </div>
    </Container>
  );
};

export default Duplicates;
